import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import { StyledSelect } from './RegionsListStyles';
import { IRegion } from '@/models/regions.model';
import { getRegionActiveOptions } from '../../helpers/getOptions';
import RegionTableActions from '../../components/RegionTableActions/RegionTableActions';

type TGetPartnersTableColumns = {
  t: TFunction;
  onStatusChange: (id: string) => void;
  canManage: boolean;
};

export const getRegionsTableColumns = ({
  t,
  onStatusChange,
  canManage,
}: TGetPartnersTableColumns): ColumnsType<IRegion> => {
  return [
    {
      title: t('regions_table_region'),
      dataIndex: 'name',
      key: 'name',
      render: (name) => <span>{name}</span>,
    },
    {
      title: t('regions_table_status'),
      dataIndex: 'active',
      key: 'active',
      render: (active, record) => {
        const handleStatusChange = () => onStatusChange(record.id);
        return (
          <span>
            <StyledSelect
              key={record.id}
              $isActive={!!active}
              options={getRegionActiveOptions(t)}
              defaultValue={active}
              onChange={handleStatusChange}
              disabled={!canManage}
            />
          </span>
        );
      },
    },
    {
      title: t('regions_table_settlement'),
      dataIndex: 'main_settlement',
      key: 'main_settlement',
      render: (main_settlement) => <span>{main_settlement}</span>,
    },
    ...(canManage
      ? [
          {
            title: t('regions_table_actions'),
            key: 'actions',
            render: (_: unknown, record: IRegion) => <RegionTableActions record={record} />,
          },
        ]
      : []),
  ];
};
